/**
 * BrandMonogram — the "E" mark, ported from
 * ios/EffectiveSLP/DesignSystem/BrandMonogram.swift.
 *
 * The tile is a rounded square with the bottom-right corner pulled
 * in slightly (speech-bubble feel). The "E" sits slightly right of
 * center to leave visual room for the implied tail. Gradient runs
 * 135° from accent → accent-deep with a white sheen on the top-left.
 *
 * Variants:
 *   - static:    AppIcon / Auth / Settings
 *   - breathing: subtle 0.85s scale pulse for onboarding heroes
 */
import type { ReactElement } from 'react';

interface Props {
  size?: number;
  breathing?: boolean;
}

export function BrandMonogram({
  size = 56,
  breathing = false,
}: Props): ReactElement {
  const fontSize = Math.round(size * 0.58);
  return (
    <div
      className={
        breathing
          ? 'brand-monogram brand-monogram--breathing'
          : 'brand-monogram'
      }
      style={{ width: size, height: size, fontSize }}
      role="img"
      aria-label="EffectiveSLP"
    >
      <span>E</span>
    </div>
  );
}

interface WordmarkProps {
  size?: number;
}

export function BrandWordmark({ size = 28 }: WordmarkProps): ReactElement {
  return (
    <div className="brand-wordmark" style={{ fontSize: size * 0.55 }}>
      <BrandMonogram size={size} />
      <span>EffectiveSLP</span>
    </div>
  );
}
